import { shopRoles } from '../constants/shopRoles';

export const shopPermissionsParser = permissions => {
  const roles = [];

  if (permissions.admin) {
    roles.push(shopRoles.SHOP_ADMIN);
  }

  if (permissions.user) {
    roles.push(shopRoles.SHOP_USER);
  }

  if (permissions.scopeExplorer) {
    roles.push(shopRoles.SHOP_SCOPE_EXPLORER);
  }

  if (permissions.issuerDashboard) {
    roles.push(shopRoles.ISSUER_DASHBOARD);
  }

  return roles;
};
